import React from 'react'

const Asterisk = () => {
  return <span style={{ marginLeft: 2, color: 'red' }}>*</span>
}

export default Asterisk
